import type { ReactNode } from 'react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  width?: string;
}

export default function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  width = 'max-w-lg',
}: ModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/40" onClick={onClose} />
      <div
        role="dialog"
        aria-modal="true"
        className={`relative w-full ${width} max-h-[86vh] overflow-y-auto rounded-xl border border-background-200 bg-background-50 p-6 shadow-lg`}
      >
        {title ? (
          <div className="mb-4 flex items-start justify-between gap-4">
            <h3 className="text-lg font-semibold text-foreground-900">{title}</h3>
            <button
              type="button"
              onClick={onClose}
              aria-label="关闭"
              className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-800 cursor-pointer"
            >
              <i className="ri-close-line text-lg" />
            </button>
          </div>
        ) : null}
        <div className="text-sm text-foreground-700">{children}</div>
        {footer ? <div className="mt-6 flex justify-end gap-3">{footer}</div> : null}
      </div>
    </div>
  );
}
